



























import { Component, Prop } from "vue-property-decorator";
import DataTable from "@/shared/components/data-table.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
import Confirm from "@/shared/components/confirm.vue";
import EnvioEmail from "../components/EnvioEmail.vue";
import ResetarSenha from "../components/ResetarSenha.vue";
import AtivarInativarConsultor from "../components/AtivarInativarConsultor.vue";
import AlterarEmail from "../components/AlterarEmail.vue";
import DataUtilizacaoAplicativo from "../components/DataUtilizacaoAplicativo.vue";

@Component({
  components: {
    DataTable,
    Confirm,
    EnvioEmail,
    ResetarSenha,
    AtivarInativarConsultor,
    AlterarEmail,
    DataUtilizacaoAplicativo,
  },
})
export default class TabAcesso extends mixins(GlobalMixin) {
  @Prop() idConsultor!: number;

  emailAtualizado(email: string) {
    this.$emit("emailAtualizado", email);
  }

  public atualizarConsultorSelecionado(){
    const envioEmail = this.$refs.envioEmail as EnvioEmail;
    envioEmail.fetchConsultoresSelecionado(this.idConsultor);
  }

}
